import { UseReferencesByClaimResult } from 'features/fact-grabbing/useReferencesByClaim';
import { create } from 'zustand';

type ClaimReferencesCacheState = {
  cache: Record<string, UseReferencesByClaimResult>;
};

type ClaimReferencesCacheActions = {
  getFromCache: (claimText: string) => UseReferencesByClaimResult | undefined;
  addToCache: (claimText: string, result: UseReferencesByClaimResult) => void;
  hasInCache: (claimText: string) => boolean;
  clearCache: () => void;
};

const initialState: ClaimReferencesCacheState = {
  cache: {}
};

export const useClaimReferencesCacheStore = create<
  ClaimReferencesCacheState & ClaimReferencesCacheActions
>((set, get) => ({
  ...initialState,

  getFromCache: (claimText: string) => {
    return get().cache[claimText];
  },

  addToCache: (claimText: string, result: UseReferencesByClaimResult) => {
    set(state => ({
      cache: {
        ...state.cache,
        [claimText]: result
      }
    }));
  },

  hasInCache: (claimText: string) => {
    return !!get().cache[claimText];
  },

  clearCache: () => {
    set({ cache: {} });
  }
}));
